import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBodyClass from 'vue-body-class'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import Pricing from '../views/Pricing.vue'
import NotFoundComponent from '../views/NotFoundComponent.vue'
import Legal from '../views/Legal.vue'
import Features from '../views/Features.vue'
import Business from '../views/Business.vue'
import IndexBlog from '../components/blog/IndexBlog.vue'
import IndexWork from '../components/work/IndexWork.vue'

Vue.use(VueRouter)

import BlogEntries from '../statics/data/blogs.json'
import WorkEntries from '../statics/data/projects.json'

const blogRoutes = Object.keys(BlogEntries).map(section => {
  const children = BlogEntries[section].map(child => ({
    path: child.id,
    name: child.id,
    component: () => import(`../markdowns/blog/${section}/${child.id}.md`)
  }))
  return {
    path: `/${section}`,
    name: section,
    component: () => import('../components/blog/Blog.vue'),
    children
  }
})

const workRoutes = Object.keys(WorkEntries).map(section => {
  const children = WorkEntries[section].map(child => ({
    path: child.id,
    name: child.id,
    component: () => import(`../markdowns/work/${section}/${child.id}.md`)
  }))
  return {
    path: `/${section}`,
    name: section,
    component: () => import('../components/work/Work.vue'),
    children
  }
})

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { bodyClass: 'route-index' }
  },
  {
    path: '/app',
    name: 'Home',
    component: Home,
    meta: { bodyClass: 'route-home' }
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: { bodyClass: 'route-pricing' }
  },
  {
    path: '/engineering/blog',
    name: 'indexblog',
    component: IndexBlog
  },
  ...blogRoutes,
  {
    path: '/work',
    name: 'indexwork',
    component: IndexWork
  },
  ...workRoutes,
  {
    path: '*',
    name: 'NotFoundComponent',
    component: NotFoundComponent,
    meta: { bodyClass: 'route-404' }
  },
  {
    path: '/design',
    name: 'Design',
    meta: { bodyClass: 'route-design' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "design" */ '../views/Design.vue')
  },
  {
    path: '/changelog',
    name: 'Changelog',
    meta: { bodyClass: 'route-changelog' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "changelog" */ '../views/Changelog.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { bodyClass: 'route-about' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/people',
    name: 'People',
    meta: { bodyClass: 'route-people' },
    // route level code-splitting
    // this generates a separate chunk (people.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "people" */ '../views/People.vue')
  },
  {
    path: '/engineering',
    name: 'Engineering',
    meta: { bodyClass: 'route-engineering' },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "engineering" */ '../views/Engineering.vue')
    // children: [
    //   {
    //     path: 'index',
    //     name: 'Index',
    //     meta: { bodyClass: 'route-engineering-stories' },
    //     component: () =>
    //       import(
    //         /* webpackChunkName: "engineering-story" */ '../components/blog/Index.vue'
    //       )
    //   }
    // ]
  },
  {
    path: '/legal',
    name: 'Legal',
    component: Legal,
    meta: { bodyClass: 'route-legal' },
    children: [
      {
        path: 'privacy',
        name: 'Privacy',
        meta: { bodyClass: 'route-privacy' },
        component: () =>
          import(
            /* webpackChunkName: "privacy-policy" */ '../views/legal/Privacy.vue'
          )
      },
      {
        path: 'terms',
        name: 'Terms',
        meta: { bodyClass: 'route-terms' },
        component: () =>
          import(
            /* webpackChunkName: "terms-of-use" */ '../views/legal/Terms.vue'
          )
      },
      {
        path: 'cookies-policy',
        name: 'Cookies',
        meta: { bodyClass: 'route-cookies' },
        component: () =>
          import(
            /* webpackChunkName: "cookies-policy" */ '../views/legal/Cookies.vue'
          )
      }
    ]
  },
  {
    path: '/features',
    name: 'Features',
    component: Features,
    meta: { bodyClass: 'route-features' },
    children: [
      {
        path: 'dark-mode',
        name: 'DarkModeFeature',
        meta: { bodyClass: 'dark-mode' },
        component: () =>
          import(
            /* webpackChunkName: "dark-mode-feature" */ '../views/features/DarkModeFeature.vue'
          )
      },
      {
        path: 'radar',
        name: 'RadarFeature',
        meta: { bodyClass: 'route-radar' },
        component: () =>
          import(
            /* webpackChunkName: "radar-feature" */ '../views/features/RadarFeature.vue'
          )
      }
    ]
  },
  {
    path: '/business',
    name: 'Business',
    component: Business,
    meta: { bodyClass: 'route-business' },
    children: [
      {
        path: 'jobs',
        name: 'Jobs',
        meta: { bodyClass: 'jobs' },
        component: () =>
          import(
            /* webpackChunkName: "jobs-business" */ '../views/business/Jobs.vue'
          )
      }
    ]
  }
]

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function(to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash

      // specify offset of the element
      if (to.hash === '#anchor2') {
        position.offset = { y: 100 }
      }

      // bypass #1number check
      if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
        return position
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false
    }

    return new Promise(resolve => {
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // coords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      // wait for the out transition to complete (if necessary)
      this.app.$root.$once('triggerScroll', () => {
        // if the resolved position is falsy or an empty object,
        // will retain current scroll position.
        resolve(position)
      })
    })
  }
}

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

const vueBodyClass = new VueBodyClass(routes)
router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next)
})

export default router
